export default __webpack_public_path__ + "img/48a6cd4b1dc6aa5f3a6e677dfc5025af.png";